import type { ReactNode } from 'react'

type ChipTone = 'dark' | 'soft'

const TONE: Record<ChipTone, string> = {
  dark: 'bg-violet-900 text-white-50',
  soft: 'bg-yellow-50 text-yellow-800',
}

export function Chip({
  tone,
  className = '',
  children,
}: {
  tone: ChipTone
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={[
        'inline-flex items-center justify-center rounded-[5px] border border-[rgb(0_0_0/5%)] px-3 py-[3px] text-label font-medium whitespace-nowrap',
        TONE[tone],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  )
}
